import { Box, CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function LoadingScreen({ message }: { message?: string }) {
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant='body1' color='text.secondary'>
        {message || t('common.loadingPleaseWait')}
      </Typography>
    </Box>
  )
}
